import React from "react";
import UserManagementArea from "../../container/userManagementContainer/UserManagementArea";
import { ConfigProvider } from "antd";

const UserManagementPage = () => {
    return (
        <main>

            <div className="raw-data-page" style={{height:'100vh'}}>
                <UserManagementArea />
            </div>

        </main>
    );
};

export default UserManagementPage;
